import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '@digital-realty/ix-button/ix-button.js';
import '@digital-realty/ix-dialog/ix-dialog.js';
import '@digital-realty/ix-radio/ix-radio.js';
import { TWStyles } from '../styles/tw.js';
import { renderBlurb } from './partials/cookie.js';

export class IxCookieBanner extends LitElement {
  static styles = [TWStyles];

  @property({ type: String, attribute: 'policy-url' }) policyUrl: string =
    '/cookie-policy';

  render() {
    return html`
      <section
        id="wrapper"
        class="flex z-[999] flex-col fixed top-0 left-0 bottom-0 right-0"
      >
        <div class="grow flex pointer-events-none bg-black opacity-50"></div>

        <div class="bg-surface-container-lowest p-6">
          <h1 class="dlr-text-heading mb-2">Cookie Settings</h1>
          <div class="flex flex-col lg:flex-row gap-9">
            <div>${renderBlurb(this.policyUrl)}</div>
            <div class="flex flex-col gap-4 justify-center">
              <div class="flex flex-wrap gap-2 lg:flex-nowrap">
                <ix-button
                  data-testid="cookie-banner-accept"
                  class="shrink-0"
                  @click=${() => {
                    this.dispatchEvent(new CustomEvent('accept-all'));
                  }}
                  >Accept all</ix-button
                >
                <ix-button
                  data-testid="cookie-banner-reject"
                  class="shrink-0"
                  @click=${() => {
                    this.dispatchEvent(new CustomEvent('reject-all'));
                  }}
                  >Reject all</ix-button
                >
                <ix-button
                  data-testid="cookie-banner-customise"
                  class="shrink-0"
                  @click=${() => {
                    this.dispatchEvent(new CustomEvent('customise-cookies'));
                  }}
                  appearance="outlined"
                  >Customize settings</ix-button
                >
              </div>
              <div class="lg:text-center">
                <span
                  data-testid="cookie-banner-no-sell"
                  tabindex="0"
                  class="underline dlr-text-small"
                  role="button"
                  @keydown=${(event: KeyboardEvent) => {
                    if (event.code === 'Enter' || event.code === 'Space') {
                      this.dispatchEvent(new CustomEvent('no-sell'));
                    }
                  }}
                  @click=${() => {
                    this.dispatchEvent(new CustomEvent('no-sell'));
                  }}
                >
                  Do Not Sell or Share My Personal Information
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
  }
}

window.customElements.define('ix-cookie-banner', IxCookieBanner);
